<template>
  <div class="productDetails">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.LoadingReport.Product_Details') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Front_View') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.lmediaFront"
          :otherData="{
            mediaName: '正面',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaFront',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Side_View') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.lmediaSide"
          :otherData="{
            mediaName: '侧面',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaSide',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Back_View') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.lmediaBack"
          :otherData="{
            mediaName: '背面',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaBack',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Inside_View') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.lmediaInside"
          :otherData="{
            mediaName: '内部',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaInside',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Details') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.lmediaPrintdetail"
          :otherData="{
            mediaName: '细节',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaPrintdetail',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Product_Color') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.lmediaColor"
          :otherData="{
            mediaName: '产品颜色对比',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaColor',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';

export default {
  data() {
    return {
      id: this.$route.query.id,
    };
  },
  computed: {
    supervisionDetails: {
      get() {
        return this.$store.state.report.supervisionDetails;
      },
      set(val) {
        this.$store.commit('report/save', { supervisionDetails: val });
      },
    },
    productProcess: {
      get() {
        return JSON.parse(
          JSON.stringify(
            this.$store.state.report.supervisionImgList.productProcess,
          ),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {},
  methods: {},
};
</script>
<style lang="less">
.productDetails {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
    }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table2 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .desOfGoods-table3 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
.reportModal1 {
  .updataForm {
    display: flex;
    .ant-form-item-label {
      text-align: left;
    }
    > div {
      width: 50%;
    }
    .title {
      width: 70%;
      text-align: center;
      margin-top: 5px;
      > button {
        margin-bottom: 3px;
      }
    }
    .part {
      width: 70%;
      padding-top: 10px;
      border-bottom: 1px dashed rgba(25, 21, 37, 0.28);
      display: flex;
      .ant-form-item-label {
        flex-shrink: 0;
      }
      .ant-row {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
